export const DestinationInputTypeEnum = {
  SINGLE: "single",
  FILE: "file",
  GROUP: "group",
};

export const DestinationTypeEnum = {
  LIST: 0,
  SAVED_LIST: 1,
  FILE: 2,
};

export const FileFormatEnum = {
  DESTINATION_WITH_MESSAGE: 0,
  DESTINATION_ONLY: 1,
};

export const ContentTypeEnum = {
  TEXT: 0,
  BINARY: 1,
  SPECIAL_BINARY: 2,
};

export const fileFormatLabels = {
  [FileFormatEnum.DESTINATION_WITH_MESSAGE]: "Números e Mensagens",
  [FileFormatEnum.DESTINATION_ONLY]: "Números",
};

export const contentTypeLabels = {
  [ContentTypeEnum.TEXT]: "Texto",
  [ContentTypeEnum.BINARY]: "Binário",
  [ContentTypeEnum.SPECIAL_BINARY]: "Binário Especial",
};
